import React, { type ReactNode, useState } from 'react'

import type { SizeChartProps } from '@vp/lat-react-component-library'

import { useProject } from '../../../root/contexts/ProjectContext'
import { useTracking } from '../../../root/contexts/TrackingContext'
import { TrackingLabel } from '../../../root/contexts/TrackingContext/TrackingConstants'

export interface ISizeChartContext {
  sizeChart: SizeChartProps | undefined
  isSizeChartLoaded: boolean
  handleSizeChartClick: () => void
  handleSizeChartClosed: () => void
  isSizeChartModalOpen: boolean
  setIsSizeChartModalOpen: (isOpen: boolean) => void
}

export const SizeChartContext = React.createContext({} as ISizeChartContext)

export type SizeChartContextProps = {
  sizeChart: SizeChartProps | undefined
  isSizeChartLoaded: boolean
  children: ReactNode
}

const SizeChartContextProvider: React.FC<SizeChartContextProps> = ({ children, sizeChart, isSizeChartLoaded }) => {
  const { mpvId, productName, productKey, productVersion, projectNumber } = useProject()
  const { trackSizeChartOpened, trackSizeChartClosed } = useTracking()

  const [isSizeChartModalOpen, setIsSizeChartModalOpen] = useState(false)

  const handleSizeChartClick = () => {
    setIsSizeChartModalOpen(true)

    const label = projectNumber > 1 ? TrackingLabel.RELATED_PRODUCT_SIZE_CHART_OPEN : TrackingLabel.SIZE_CHART_OPEN
    trackSizeChartOpened(label, mpvId, productName, productKey, productVersion)
  }

  const handleSizeChartClosed = () => {
    const label = projectNumber > 1 ? TrackingLabel.RELATED_PRODUCT_SIZE_CHART_CLOSE : TrackingLabel.SIZE_CHART_CLOSE
    trackSizeChartClosed(label, mpvId, productName, productKey, productVersion)
    setIsSizeChartModalOpen(false)
  }

  return (
    <SizeChartContext.Provider
      value={{
        sizeChart,
        isSizeChartLoaded,
        handleSizeChartClick,
        handleSizeChartClosed,
        isSizeChartModalOpen,
        setIsSizeChartModalOpen,
      }}
    >
      {children}
    </SizeChartContext.Provider>
  )
}

export default SizeChartContextProvider
